import { Badge } from "@material-ui/core";
import {
    Search,
    ShoppingCartOutlined,
    List,
    Close,
    ExitToApp,
    Person,
    Archive,
} from "@material-ui/icons";
import { HiLockOpen } from "react-icons/hi";
import styled from "styled-components";
import { mobile, tablet } from "../responsive";
import { Link, useHistory } from "react-router-dom";
import { logout } from "../redux/userRedux";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { clearCart } from "../redux/cartRedux";
import { FormattedMessage } from "react-intl";

const Container = styled.div`
    height: 80px;
    ${mobile({ height: "inherit" })}
`;

const MenuContainer = styled.div`
    padding-top: 30px;
`;

const Wrapper = styled.div`
    padding: 10px 50px;
    display: grid;
    grid-template-columns: 33.33% 33.33% 33.33%;
    ${mobile({ padding: "10px 0px", display: "none" })}
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
`;

const LeftContainer = styled.div`
    cursor: pointer;
    margin-right: 30px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    &:hover {
        background: linear-gradient(135deg, rgba(55, 72, 54, 0.1) 0%, rgba(68, 94, 79, 0.05) 100%);
        color: #2D3A2B;
    }
    ${mobile({ marginRight: "10px", padding: "8px 12px" })}
`;

const RightContainer = styled.div`
    cursor: pointer;
    margin-right: 30px;
    display: flex;
    align-items: center;

    ${mobile({ display: "none" })}
    ${tablet({ display: "none" })}
`;

const Center = styled.div`
    flex: 1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Cursor = styled.div`
    cursor: pointer;
    textdecoration: "none";
    color: "black";
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Logo = styled.img`
    height: 70px;
    ${mobile({ maxHeight: "4vh", marginLeft: "5vh" })}
`;

const Right = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${mobile({ flex: 2, justifyContent: "center" })}
`;

const MenuItem = styled.div`
    font-size: 14px;
    cursor: pointer;
    margin-left: 25px;
    ${mobile({ fontSize: "12px", marginLeft: "0px" })}
`;

const NavbarAuth = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    ${mobile({ fontSize: "12px", marginLeft: "10px" })}
    &.hidden {
        display: none;
    }
`;

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    background: linear-gradient(135deg, rgba(55, 72, 54, 0.1) 0%, rgba(68, 94, 79, 0.05) 100%);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 10;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const ModalTitle = styled.h1`
    cursor: pointer;
    margin: 0.75rem 0rem;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    padding: 12px 0;
    color: #374836;
    border-bottom: 1px solid rgba(68, 94, 79, 0.1);
    border-radius: 8px;
    transition: all 0.3s ease;
    &:hover {
        background: linear-gradient(135deg, rgba(55, 72, 54, 0.1) 0%, rgba(68, 94, 79, 0.05) 100%);
        color: #2D3A2B;
        transform: translateX(8px);
        border-bottom: 1px solid rgba(68, 94, 79, 0.2);
    }
    ${tablet({ fontSize: "1rem" })}
`;

const Overlay = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    height: calc(100vh - 80px);
    z-index: 11;
    padding: 20px 0;
`;

const ModalDetails = styled.div`
    background: linear-gradient(135deg, rgba(249, 251, 243, 0.95) 0%, rgba(217, 222, 213, 0.9) 100%);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(55, 72, 54, 0.15);
    border: 1px solid rgba(68, 94, 79, 0.1);
    color: #374836;
    height: fit-content;
    max-height: 80vh;
    width: 320px;
    display: flex;
    z-index: 11;
    margin-left: 50px;
    overflow: hidden;
    transform: translateX(-100%);
    opacity: 0;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    ${mobile({
        width: "100%",
        height: "100%",
        maxHeight: "100vh",
        marginLeft: "0",
        borderRadius: "0",
        transform: "translateX(0)",
        background: "linear-gradient(135deg, rgba(249, 251, 243, 0.98) 0%, rgba(217, 222, 213, 0.95) 100%)"
    })}
    &.open {
        transform: translateX(0);
        opacity: 1;
    }
`;

const ModalItemContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 2rem 2rem 2.5rem 2rem;
    width: 100%;
    z-index: 13;
    background: transparent;
    ${mobile({ padding: "1.5rem 1rem 2rem 1rem" })}
`;

const InputContainer = styled.div`
    width: 100%;
    height: 40px;
    background-color: white;
    display: flex;
    border: 1px solid lightgray;
    margin-right: 10px;
    ${tablet({ width: "50%", display: "none" })}
`;

const Input = styled.input`
    border: none;
    flex: 8;
    padding-left: 20px;
    ${mobile({ fontSize: "0.8rem" })}
`;

const ScrollContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 40px;
    border: none;
    background-color: var(--wellness-primary);
    color: white;
    overflow: hidden;
`;

const ScrollText = styled.div`
text-align: center;
display: block;
${mobile({ display: "none" })}
/* animation properties */
-moz-transform: translateX(-100%);
-webkit-transform: translateX(-100%);
transform: translateX(-100%);

-moz-animation: my-animation 15s linear infinite;
-webkit-animation: my-animation 15s linear infinite;
animation: my-animation 15s linear infinite;
}

/* for Firefox */
@-moz-keyframes my-animation {
from { -moz-transform: translateX(-100%); }
to { -moz-transform: translateX(100%); }
}

/* for Chrome */
@-webkit-keyframes my-animation {
from { -webkit-transform: translateX(-100%); }
to { -webkit-transform: translateX(100%); }
}

@keyframes my-animation {
from {
  -moz-transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
to {
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}


`;

const MobileScrollText = styled.div`
text-align: center;
display: none;
${mobile({ display: "block" })}
/* animation properties */
-moz-transform: translateX(-100%);
-webkit-transform: translateX(-100%);
transform: translateX(-100%);

-moz-animation: my-animation 15s linear infinite;
-webkit-animation: my-animation 15s linear infinite;
animation: my-animation 15s linear infinite;
}

/* for Firefox */
@-moz-keyframes my-animation {
from { -moz-transform: translateX(-100%); }
to { -moz-transform: translateX(100%); }
}

/* for Chrome */
@-webkit-keyframes my-animation {
from { -webkit-transform: translateX(-100%); }
to { -webkit-transform: translateX(100%); }
}

@keyframes my-animation {
from {
  -moz-transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
to {
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}


`;

const Navbar = ({onLocaleChange, locale}) => {
    const quantity = useSelector((state) => state.cart.quantity);
    const currentUser = useSelector((state) => state.user);
    const [showMenu, setShowMenu] = useState(false);
    const [model, setModel] = useState(undefined);
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(logout());
        dispatch(clearCart());
    };

    const history = useHistory();

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            history.push({
                pathname: "/search",
                state: { model: model },
            });
        }
    };

    useEffect(() => {
        if (showMenu === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [showMenu]);

    return (
        <>
            <Container>
                <Wrapper>
                    {" "}
                    <Left>

                        <Cursor>
                            <ul onClick={() => setShowMenu(!showMenu)}>
                                {showMenu ? (
                                    <LeftContainer>
                                        <Close></Close><FormattedMessage id="navbar_subtitle_menu" defaultMessage="" />
                                    </LeftContainer>
                                ) : (
                                    <LeftContainer>
                                        <List></List><FormattedMessage id="navbar_subtitle_menu" defaultMessage="" />
                                    </LeftContainer>
                                )}
                            </ul>
                        </Cursor>

                        <LeftContainer>
                            <InputContainer>
                                <Input
                                    onChange={(e) => setModel(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    placeholder={"Search here"}
                                />
                            </InputContainer>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                                to={{
                                    pathname: "/search",
                                    state: {
                                        model: model,
                                    },
                                }}
                            >
                                <Search></Search>{" "}
                            </Link>
                        </LeftContainer>
                    </Left>
                    <Center>
                        <Link
                            style={{ textDecoration: "none", color: "black" }}
                            to="/"
                        >
                            <Logo
                                src={
                                    "https://ik.imagekit.io/dnddecpho/airvitamin/air-logo_xVbwmEdOS.jpg?updatedAt=1734429910967"
                                }
                            ></Logo>
                        </Link>
                    </Center>
                    {currentUser ? currentUser.currentUser !== null ? (
                        <Right>
                            <RightContainer>
                            <div className="flex justify-center mr-4">
      <select className="w-24 text-center" value={locale} onChange={(e) => onLocaleChange(e.target.value)}>
        <option value="en">English</option>
        <option value="es">中文</option>
      </select>
    </div>
                            <FormattedMessage id="navbar.welcome" defaultMessage="Welcome!" />, {currentUser ? currentUser.currentUser ? currentUser.currentUser.name : "" : ""}
                            </RightContainer>

                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                                to="/login"
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser !== null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <HiLockOpen
                                        style={{ fontSize: "23px" }}
                                    ></HiLockOpen>
                                </NavbarAuth>
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                                to="/cart"
                            >
                                <MenuItem>
                                    <Badge
                                        badgeContent={quantity}
                                        color="primary"
                                    >
                                        <ShoppingCartOutlined />
                                    </Badge>
                                </MenuItem>
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                    marginRight: "20px",
                                    marginLeft: "20px",
                                }}
                                to="/order"
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser === null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <Archive></Archive>
                                </NavbarAuth>
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                    marginRight: "20px",
                                }}
                                to="/profile"
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser === null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <Person></Person>
                                </NavbarAuth>
                            </Link>

                            <div
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                    cursor: "pointer",
                                }}
                                className={
                                    currentUser.currentUser == null
                                        ? "hidden"
                                        : null
                                }
                                onClick={handleClick}
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser == null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <ExitToApp></ExitToApp>
                                </NavbarAuth>
                            </div>
                        </Right>
                    ) : (
                        <></>
                    ) : (
                        <></>
                    )}
                    {currentUser ?currentUser.currentUser === null ? (
                        <Right>
                            
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                    marginRight: "20px",
                                    marginLeft: "20px",
                                }}
                                to="/order"
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser === null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <Archive></Archive>
                                </NavbarAuth>
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                    marginRight: "20px",
                                }}
                                to="/profile"
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser === null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <Person></Person>
                                </NavbarAuth>
                            </Link>

                            <RightContainer>
                            <div className="flex justify-center mr-4">
      <select className="w-24 text-center" value={locale} onChange={(e) => onLocaleChange(e.target.value)}>
        <option value="en">English</option>
        <option value="es">中文</option>
      </select>
    </div>
                                <Link
                                    style={{
                                        textDecoration: "none",
                                        color: "black",
                                    }}
                                    to="/register"
                                >
                                    <NavbarAuth
                                        className={
                                            currentUser.currentUser !== null
                                                ? "hidden"
                                                : null
                                        }
                                    >
                                        <FormattedMessage id="navbar_subtitle_register" defaultMessage="" />
                                    </NavbarAuth>
                                </Link>
                            </RightContainer>

                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                                to="/login"
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser !== null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <HiLockOpen
                                        style={{ fontSize: "23px" }}
                                    ></HiLockOpen>
                                </NavbarAuth>
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                                to="/cart"
                            >
                                <MenuItem>
                                    <Badge
                                        badgeContent={quantity}
                                        color="primary"
                                    >
                                        <ShoppingCartOutlined />
                                    </Badge>
                                </MenuItem>
                            </Link>

                            <div
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                    cursor: "pointer",
                                }}
                                className={
                                    currentUser.currentUser == null
                                        ? "hidden"
                                        : null
                                }
                                onClick={handleClick}
                            >
                                <NavbarAuth
                                    className={
                                        currentUser.currentUser == null
                                            ? "hidden"
                                            : null
                                    }
                                >
                                    <ExitToApp></ExitToApp>
                                </NavbarAuth>
                            </div>
                        </Right>
                    ) : (
                        <></>
                    ) : (
                        <></>
                    )}
                </Wrapper>
                {showMenu && (
                    <OverlayContainer>
                        <ModalContainer></ModalContainer>
                        <Overlay>
                            <ModalDetails className={showMenu ? "open" : ""}>
                                <ModalItemContainer>
                                    <LeftContainer
                                        onClick={() => setShowMenu(false)}
                                    >
                                        <Close style={{ color: "#374836" }}></Close><FormattedMessage id="navbar_subtitle_close" defaultMessage="" />
                                    </LeftContainer>
                                    <MenuContainer>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle><FormattedMessage id="navbar_subtitle_1" defaultMessage="" /></ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/about"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle><FormattedMessage id="navbar_subtitle_2" defaultMessage="" /></ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/background"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle>
                                            <FormattedMessage id="navbar_subtitle_3" defaultMessage="" />
                                            </ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/demo"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle>
                                            <FormattedMessage id="navbar_subtitle_4" defaultMessage="" />
                                            </ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/gallery"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle>
                                            <FormattedMessage id="navbar_subtitle_5" defaultMessage="" />
                                            </ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/product/G10"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle>
                                            <FormattedMessage id="navbar_subtitle_6" defaultMessage="" />
                                            </ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/search"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle>
                                            <FormattedMessage id="navbar_subtitle_7" defaultMessage="" />
                                            </ModalTitle>
                                        </Link>
                                        <Link
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                            }}
                                            to="/contact"
                                            onClick={() => setShowMenu(false)}
                                        >
                                            <ModalTitle><FormattedMessage id="navbar_subtitle_8" defaultMessage="" /></ModalTitle>
                                        </Link>
                                    </MenuContainer>
                                </ModalItemContainer>
                            </ModalDetails>
                        </Overlay>
                    </OverlayContainer>
                )}
            </Container>
            <ScrollContainer>
                <ScrollText>
                <FormattedMessage id="notice_bar" defaultMessage="" />
                </ScrollText>
                <MobileScrollText>
                <FormattedMessage id="notice_bar" defaultMessage="" />
                </MobileScrollText>
            </ScrollContainer>
        </>
    );
};

export default Navbar;
